// extracted by mini-css-extract-plugin
export default {"durationLabel":"DurationField_durationLabel__OQmxG"};